import {
  ArrowDownNarrowWide,
  ArrowUpDown,
  ArrowUpNarrowWide,
} from "lucide-react";
import {
  AllowedAggOrderBy,
  AllowedInteractionOrderBy,
  exploreOrderByTypeToLabel,
} from "./ExploreDisplayOptions.model";
import { Button } from "@/components/ui/button";
import Select from "@/components/shared/select";

interface OrderingSectionProps {
  orderByLabel: string;
  activeOrderBy?: string;
  activeOrderDir?: "asc" | "desc";
  availableOptions: (AllowedInteractionOrderBy | AllowedAggOrderBy)[];
  onOrderByChange: (
    orderBy: AllowedInteractionOrderBy | AllowedAggOrderBy
  ) => void;
  onOrderDirToggle: () => void;
}

export function OrderingSection({
  orderByLabel,
  activeOrderBy,
  activeOrderDir,
  availableOptions,
  onOrderByChange,
  onOrderDirToggle,
}: OrderingSectionProps) {
  return (
    <div className="flex flex-col gap-2 w-full">
      <div className="flex items-center gap-1">
        <div className="flex items-center gap-2 w-[125px] flex-shrink-0">
          <ArrowUpDown className="text-gray-500 size-4" />
          <label className="text-sm text-gray-500">Ordering</label>
        </div>

        <div className="flex-1 min-w-0">
          <Select
            classes={{
              root: "w-full",
              value: "truncate",
            }}
            size="medium"
            options={availableOptions.map((option) => ({
              label: exploreOrderByTypeToLabel[option],
              value: option,
            }))}
            placeholder="Select Order By"
            value={activeOrderBy}
            onChange={(value) =>
              onOrderByChange(
                value as AllowedInteractionOrderBy | AllowedAggOrderBy
              )
            }
          />
        </div>

        <div className="flex-shrink-0">
          <Button
            variant="ghost"
            size="icon"
            onClick={onOrderDirToggle}
            className="size-8"
          >
            {activeOrderDir === "desc" ? (
              <ArrowDownNarrowWide className="size-4" />
            ) : (
              <ArrowUpNarrowWide className="size-4" />
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
